import * as React from "react";
import "./input.css";
import "../../style/fonts.css";
import FailureMessage from "./failureMessage/failureMessage";

export interface Props {
  type: string;
  placeholder: string;
  value: string;
  onChange: any;
  warning: string;
  passwordSeen: any;
}

class Input extends React.Component<Props, any> {
  constructor(props) {
    super(props);
  }

  render() {
    if (
      this.props.type == "text" ||
      this.props.passwordSeen ||
      this.props.value === ""
    ) {
      return (
        <div className="INPUT_CONT">
          <label>
            <input
              autoCapitalize="none"
              type={"text"}
              placeholder={this.props.placeholder}
              value={this.props.value}
              onChange={this.props.onChange}
            />
          </label>
          <FailureMessage text={this.props.warning} />
        </div>
      );
    } else if (this.props.type == "password") {
      return (
        <div className="INPUT_CONT">
          <label>
            <input
              autoCapitalize="none"
              type={"password"}
              placeholder={this.props.placeholder}
              value={this.props.value}
              onChange={this.props.onChange}
              autoFocus
            />
          </label>
          <FailureMessage text={this.props.warning} />
        </div>
      );
    } else return null;
  }
}

export default Input;



// WEBPACK FOOTER //
// ./src/components/input/input.tsx